import { A, createAsync, query } from "@solidjs/router";
import { Show, createSignal, onMount, createEffect, createMemo, Switch, Match } from "solid-js";

import { getByUserQuery, formatLongDate, orderedJoin, schemeData, padId } from "~/lib";
import { queryByPK } from "~/_server/dynamoDB";

export const Subscription = props => {
	const [subscription, setSubscription] = createSignal( props.subscription );
	const [approvedBody, setApprovedBody] = createSignal();

	onMount( async () => {
		if ( !props.subscription && props.subscriptionId ) {
			const s = await getByUserQuery( 'SCHEME', props.scheme.id );
			console.log( "Got subscription", s );
			setSubscription( s.SCHEME );
		}
	} );

	//const approvedBody = createAsync( () => getByPKQuery( `APPROVEDBODY#${subscription().approvedBodyId}`, null) );

	createEffect( async () => {
		if ( subscription().approvedBodyId ) {
			const ab = await queryByPK( `APPROVEDBODY#${subscription().approvedBodyId}`, '' );

			if ( ab && ab.length > 0 ) {
				setApprovedBody( ab[0] );
			}
		}
	} );

	const ABDisplay = () => <>{approvedBody()?.address?.title}{approvedBody()?.riasId ? " - " : ""}<em>{approvedBody()?.riasId ? approvedBody()?.scheme + '-DB-' + padId( approvedBody().riasId ) : 'n/a'}</em></>;

	return (
		<>
			<Show when={!props.longForm}>
				<div class="grid grid-cols-2 gap-3" onClick={props.onClick} classList={props.classList}>
					<span>{schemeData( subscription().scheme ).name}</span>
					<span>{subscription().name}</span>
					<span class="col-span-2"><ABDisplay /></span>
					<span class="col-span-2 text-xs mt-1.5">Expires {formatLongDate( subscription().expires )}</span>
				</div>
			</Show>

			<Show when={props.longForm}>
				<Show when={subscription().status == "validating"}>
					<div class="text-center bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded relative" role="alert">
						<p>Your application for membership is being validated. This process can take up to 10 working days. You will receive an email as soon as the process is complete.</p>
					</div>
				</Show>

				<Show when={subscription().status != "validating"}>
					<table class="relative min-w-full divide-y divide-gray-300">
						<tbody>
							<tr class="even:bg-gray-100">
								<td class="text-nowrap py-2 px-2 text-xs text-right">Certifier ID:</td>
								<td class="font-bold py-2 text-sm">{subscription().name}</td>
							</tr>
							<tr class="even:bg-gray-100">
								<td class="text-nowrap py-2 px-2 text-xs text-right">Status:</td>
								<td class="font-bold py-2 capitalize text-sm">{subscription().status}</td>
							</tr>
							<tr class="even:bg-gray-100">
								<td class="text-nowrap py-2 px-2 text-xs text-right">Renewal Date:</td>
								<td class="font-bold py-2 text-sm">{formatLongDate( subscription().expires )}</td>
							</tr>
							<tr class="even:bg-gray-100">
								<td class="text-nowrap py-2 px-2 text-xs text-right">Approved Body:</td>
								<td class="font-bold py-2 text-sm"><ABDisplay /></td>
							</tr>
							<tr class="even:bg-gray-100">
								<td class="text-nowrap py-2 px-2 text-xs text-right align-baseline">Address:</td>
								<td class="font-bold py-2 text-sm">{orderedJoin( approvedBody()?.address, ["addr1", "addr2", "town", "county", "postcode"], ", " )}</td>
							</tr>
							<tr class="even:bg-gray-100">
								<td class="text-nowrap py-2 px-2 text-xs text-right">Co-ordinator:</td>
								<td class="font-bold py-2 text-sm" innerHTML={approvedBody()?.coordinator ?? 'n/a'} />
							</tr>
							<tr class="even:bg-gray-100">
								<td class="text-nowrap py-2 px-2 text-xs text-right">Deputy:</td>
								<td class="font-bold py-2 text-sm" innerHTML={approvedBody()?.deputy ?? 'n/a'} />
							</tr>
						</tbody>
					</table>

					<SubscriptionActions subscription={subscription()} />
				</Show>
			</Show>

		</>
	);
}


const SubscriptionActions = ( props ) => {
	const [sub] = createSignal( props.subscription );

	return (
		<Switch >
			<Match when={sub().status == "pending"}>
				<div class="text-center bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-lg relative" role="alert">
					<h3 class="text-lg font-bold">Over to you!</h3>

					<p>Your next step is to complete the membership assessments. <A href="/dashboard/exams">Click here to do that</A>.</p>
				</div>
			</Match>

			<Match when={sub().status == "pending"}>
				<div class="text-center bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded relative" role="alert">
					<h3>Your Approved Body</h3>

					<p>Your next step is to submit an approved body. This can be an existing body. <A href="/dashboard/approved-body">Click here to assign your Approved Body</A>.</p>
				</div>
			</Match>

			<Match when={sub().status == "suspended"} >
				<div class="text-center bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
					<h3>Subscription Suspended</h3>
				</div>
			</Match>

			<Match when={sub().status == "renewing"} >
				<div class="text-center bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded relative" role="alert">
					<h3 class="text-lg font-bold">Subscription Renewing</h3>

					<p class="my-3">Your subscription has expired, but can be renewed by paying the renewal fee. If you have not received an email regarding renewal, please <a href="mailto:support@rias-regs.co.uk">contact Support</a>.</p>

					<p class="my-3">You must not issue certificates until your subscription is renewed.</p>
				</div>
			</Match>			
		</Switch>
	);

}